import React from 'react';

import styles from './styles.module.scss';

interface Props {
  src: string;
}
//  This component fits an image into a fixed block without stretching
const HeroImageFit = ({ src }: Props) => (
  <div className={styles.heroImageFit}>
    <img src={src} alt="" />
  </div>
);

export default HeroImageFit;
